{
  "title": "The Hidden Gems of React Native",
  "shortTitle": "The Hidden Gems of React Native",
  "subtitle": "A list of hidden gems of React Native that are not so popular but can be very useful in some specific scenarios.",
  "author": "Enzo Manuel Mangano",
  "date": "2024-03-08",
  "slug": "the-hidden-gems-of-react-native",
  "tags": ["react-native", "react"],
  "featuredImage": "./images/header.webp",
  "series": "react-native-toolbelt"
}
